export interface IKeywordListItem {
    id: string;
    code: string;
    comment: string;
}

export class KeywordListItem implements IKeywordListItem {
    id: string;
    code: string;
    comment: string;

    constructor();
    constructor(obj: IKeywordListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
    }
}
